
<div class="dialog-header">
	<h1 mat-dialog-title class="title">{{ data.title }}</h1>
	<mat-icon *ngIf="data?.showClose === true || (data?.showClose  === 'auto' && (isSuccess ||querying))" [mat-dialog-close]="isSuccess ? 'done' : 'back'" class="cursor-pointer">close</mat-icon>
</div>

<div mat-dialog-content class="mt-8" *ngIf="data">

	<div class="progress-container">
			<mat-spinner *ngIf="querying" [diameter]="100" strokeWidth="4"></mat-spinner>
			<mat-icon *ngIf="querying === false" class="status-icon" [ngClass]="{'success': isSuccess,'failure': !isSuccess}">{{isSuccess ? this.data.successIcon || 'check_circle_outline' : this.data.failureIcon || 'error_outline'}}</mat-icon>

			<p class="status-text" *ngIf="data | transformObject: getMessage: querying: isSuccess: queryResponse as message" [innerHTML]="message | safeHtml"></p>
	</div>



</div>

<div mat-dialog-actions class="dialog-footer mt-5" *ngIf="querying === false">
	<button *ngIf="!isSuccess" mat-flat-button mat-dialog-close="back" color="primary" class="margin-right-auto">{{ data.backButtonText || 'Back' }}</button>

	<button *ngIf="isSuccess" mat-flat-button [mat-dialog-close]="queryResponse" color="primary" class="margin-left-auto dark">
		{{ data.successButtonText || 'Done' }}
	</button>
	<button *ngIf="!isSuccess" mat-button color="primary" mat-dialog-close="discard" class="dark">
		{{ data.failureButtonText || 'Discard and close' }}
	</button>
</div>
